<template>
    <img :src=" 'https://massaclub.com/stat/?id=10&ref=' + referrer + '&current=' + href " alt=""/>
    <!-- <img :src=" 'https://massaclub.com/stat2/?ref=' + document.referrer + '&current=' + document.location.href " alt=""/> -->
</template>

<script>
export default {
    data() {
        return {
            referrer: document.referrer,
            href: document.location.href,
        }
    }
}
</script>

<style>
</style>